//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      urlList: [{
        url: 'https://hwone.bossreport.net/view/report.do?reportId=b8d37fa67627441d9f293cddec948f28'
      }, {
        url: 'https://hwone.bossreport.net/view/report.do?reportId=142808aa3b6041a194a32f9923cbdce4'
      }, {
        url: 'https://hwone.bossreport.net/view/report.do?reportId=b8d37fa67627441d9f293cddec948f28'
      }]
    };
  },
  mounted: function mounted() {
    new Swiper('.swiper', {
      direction: 'horizontal',
      // 垂直切换选项
      loop: true,
      // 循环模式选项
      speed: 1000,
      autoplay: {
        delay: 2500,
        pauseOnMouseEnter: true,
        disableOnInteraction: false
      },
      on: {
        autoplayPause: function autoplayPause() {},
        autoplayResume: function autoplayResume() {}
      },
      // 如果需要分页器
      pagination: {
        el: '.swiper-pagination'
      },
      // 如果需要前进后退按钮
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      // 如果需要滚动条
      scrollbar: {
        el: '.swiper-scrollbar'
      }
    });
  },
  methods: {}
};